import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, UntypedFormControl } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    },
  ],
})
export class CheckboxComponent implements OnInit, OnChanges, ControlValueAccessor {
  @Input() checked: boolean;
  @Input() disabled = false;
  @Output() changedEvent = new EventEmitter<boolean>();

  formControl: UntypedFormControl = new UntypedFormControl();

  private onChange: (value: boolean) => void;
  private onTouch: () => void;

  constructor() {
  }

  ngOnInit(): void {
    this.formControl.valueChanges
      .pipe(untilDestroyed(this))
      .subscribe(val => {
        if (this.onChange) {
          this.onChange(val);
        }

        this.changedEvent.emit(val);
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.checked) {
      this.formControl.setValue(this.checked, { emitEvent: false });
    }

    if (changes.disabled) {
      this.disabled ? this.formControl.disable() : this.formControl.enable();
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    isDisabled ? this.formControl.disable() : this.formControl.enable();
  }

  writeValue(obj: any): void {
    this.formControl.setValue(obj);
  }
}
